<div class="component header text-center">
    <div class="background" [style.background-image]="picture"></div>
    <div class="blur"></div>
    

    <h1 [ngStyle]="{'color': colorValue}">{{title}}</h1>

    <h5>{{subTitle}}</h5>
</div>